var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"order-list"},_vm._l((_vm.orders),function(order){return _c('OrderLink',{attrs:{"item":order},on:{"order-deleted":_vm.orderDeleted}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }